//require('uikit');
require("../../../package/uikit/css/uikit.min.css");
require("../../../package/uikit/js/uikit.min.js");
require("./fishmeal.scss");
require("./common.scss");

require("./go-top.ts");